import { Component, OnInit, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AgenciaService } from 'src/app/servicios/agencia.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-dialog-agencias',
  templateUrl: './dialog-agencias.component.html',
  styleUrls: ['./dialog-agencias.component.css']
})
export class DialogAgenciasComponent implements OnInit {


  agencias=[];
  agenciasSet='';
  agenciaGroup:FormGroup
  loading=false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private servicioAgencia:AgenciaService,
    private formBuilder:FormBuilder

  ) {
    console.log(this.dataDialog);
    
    this.agenciaGroup=this.formBuilder.group({
      formAgencias: ['', Validators.required],
    });

    this.loading=true;
    this.servicioAgencia.getAllAgencia(0)
    .subscribe(result=>{
      this.loading=false;
      this.agencias=result;
    })

   }

  ngOnInit() {
  }

  setAgencias(selected){
    this.agenciasSet=this.agenciaGroup.controls['formAgencias'].value;
  }

}
